module.exports = __webpack_public_path__ + "static/media/carPhoto3.2b7da50e.jpg";